// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsNotEmpty, IsString } from 'class-validator';

export class ChangePasswordForm {
  @IsString()
  @IsNotEmpty()
  currentPassword: string;
  
  @IsString()
  @IsNotEmpty()
  newPassword: string;

  @IsString()
  @IsNotEmpty()
  confirmPassword: string;
}
